/*
  gangsheet-handoff-loader.js

  When a gang sheet is handed off to the gang-sheet product page from
  "My Designs" (or a reorder) via ?file= / ?my_designs_selection=, the
  upload scripts fetch + process the artwork before the preview renders —
  leaving a blank wait. This APPENDS a self-contained running-ninja loader
  card into the preview container (#fileupload_custom) and forces it
  visible, then removes it once the design is ready.

  Why a self-contained appended overlay (and not "reveal the page's own
  ldl-loader"): appending our own element always renders. Revealing the
  page's hidden loader depends on its display rules cooperating, which the
  My Designs handoff path does not. The visual here mirrors the upload
  loader (snippets/ldl-loader.liquid): ring + running-ninja gif + UPLOADING
  + percentage + rotating status. CSS lives in component-cart.css.

  Lives in an ASSET (cache-busted on every push), not inline in the section,
  because the product page HTML is cached. Self-gating: no-ops unless a
  handoff URL param is present AND #fileupload_custom exists.
*/
(function () {
  if (window.__ntGsHandoffLoader) return;
  window.__ntGsHandoffLoader = true;

  try {
    var search = window.location.search || '';
    if (search.indexOf('file=') === -1 && search.indexOf('my_designs_selection=') === -1) return;

    var NINJA = 'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/Ninja-Running-Loop-200x-200-cleaned.gif?v=1758717834';
    var STATUS = [
      'Sharpening the katana…', 'Loading at ninja speed…',
      'Consulting the scrolls…', 'Polishing the shuriken…',
      'Dusting off the ancient scrolls…', 'Tightening the headband…',
      'Unsheathing the pixels…', 'Tossing a smoke bomb…'
    ];
    var CIRC = 2 * Math.PI * 46;

    var done = false, sawLoading = false, startedAt = 0, gateTries = 0;
    var timer = null, statusTimer = null, sIdx = 0;
    var host = null, overlay = null, arc = null, numEl = null, statusEl = null;

    /* Fully INLINE-styled — must NOT depend on any external CSS file (those
       can be cache-stale, which renders the card unstyled/"broken"). */
    function buildOverlay() {
      overlay = document.createElement('div');
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.style.cssText = 'position:absolute;inset:0;z-index:60;display:flex;align-items:center;justify-content:center;background:#ffffff;border-radius:12px;box-sizing:border-box;padding:16px;';
      var card = document.createElement('div');
      card.style.cssText = 'display:flex;flex-direction:column;align-items:center;text-align:center;gap:16px;background:#E7F6FE;border-radius:20px;padding:28px 24px;max-width:100%;box-sizing:border-box;font-family:Inter,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;';
      card.innerHTML =
        '<div style="position:relative;width:160px;height:160px;max-width:56vw;flex:none;">' +
          '<svg viewBox="0 0 100 100" style="width:100%;height:100%;display:block;">' +
            '<circle cx="50" cy="50" r="46" fill="none" stroke="#ffffff" stroke-width="4"></circle>' +
            '<circle data-arc cx="50" cy="50" r="46" fill="none" stroke="#07A7F2" stroke-width="4" stroke-linecap="round" style="transform:rotate(-90deg);transform-origin:50px 50px;stroke-dasharray:' + CIRC + ';stroke-dashoffset:' + CIRC + ';transition:stroke-dashoffset 80ms linear;"></circle>' +
          '</svg>' +
          '<img src="' + NINJA + '" alt="" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:64%;height:64%;object-fit:contain;background:transparent;pointer-events:none;">' +
        '</div>' +
        '<div style="display:flex;flex-direction:column;align-items:center;">' +
          '<div data-status style="font-weight:500;font-size:13px;color:#6B7C8C;line-height:1.3;">Dusting off the ancient scrolls…</div>' +
          '<div style="margin-top:8px;font-weight:800;font-size:24px;letter-spacing:.5px;text-transform:uppercase;color:#07A7F2;line-height:1;">UPLOADING</div>' +
          '<div style="margin-top:6px;font-weight:800;font-size:32px;color:#0B1B2B;line-height:1;"><span data-num>0</span><span style="font-size:17px;color:#5B7388;margin-left:2px;">%</span></div>' +
        '</div>';
      overlay.appendChild(card);
      arc = card.querySelector('[data-arc]');
      numEl = card.querySelector('[data-num]');
      statusEl = card.querySelector('[data-status]');
    }

    function applyPct(n) {
      if (isNaN(n)) n = 0;
      if (n < 0) n = 0; if (n > 100) n = 100;
      if (numEl) numEl.textContent = Math.round(n);
      if (arc) arc.style.strokeDashoffset = CIRC * (1 - n / 100);
    }
    /* Smooth ease-out climb to ~92% (the handoff has no real upload-progress
       events). If the real pipeline ever reports higher we respect it. */
    function fauxPct() {
      var t = (Date.now() - startedAt) / 1000;
      return 92 * (1 - Math.exp(-t / 2.2));
    }
    function realPct() {
      var c = document.querySelector('#fileupload_custom .loadingPercent__counter');
      if (!c) return 0;
      var m = String(c.textContent || '').match(/-?\d+(\.\d+)?/);
      return m ? parseFloat(m[0]) : 0;
    }
    function isReady() {
      var el = Date.now() - startedAt;
      if (el < 500) return false;
      var ez = document.querySelector('preview-block.easyzoom, .easyzoom');
      if (ez && ez.classList.contains('image-loading')) { sawLoading = true; return false; }
      if (sawLoading && ez) return true;
      var hero = document.getElementById('fileupload_hero');
      if (hero && hero.naturalWidth > 1 && (hero.currentSrc || hero.src || '').indexOf('transparent.png') === -1) return true;
      return false;
    }
    function finish() {
      if (done) return; done = true;
      if (timer) clearInterval(timer);
      if (statusTimer) clearInterval(statusTimer);
      applyPct(100);
      setTimeout(function () {
        if (overlay) {
          overlay.style.transition = 'opacity .25s ease';
          overlay.style.opacity = '0';
          setTimeout(function () {
            if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
            if (host) host.style.minHeight = '';
          }, 280);
        }
      }, 250);
    }
    function tick() {
      try {
        if (isReady()) { finish(); return; }
        applyPct(Math.max(Math.min(fauxPct(), 92), realPct()));
      } catch (e) { finish(); }
    }

    function go() {
      if (!document.body) { setTimeout(go, 20); return; }
      host = document.getElementById('fileupload_custom');
      if (!host) {
        if (gateTries++ < 25) { setTimeout(go, 200); return; }
        return; /* not the gang-sheet page */
      }
      if (overlay) return;

      /* Force the preview container visible + give it a floor height so the
         loader card has somewhere to sit (it starts display:none and may be
         empty until the design loads). */
      host.style.display = 'block';
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (!host.style.minHeight) host.style.minHeight = '340px';

      buildOverlay();
      host.appendChild(overlay);

      startedAt = Date.now();
      tick();
      timer = setInterval(tick, 120);
      statusTimer = setInterval(function () {
        sIdx = (sIdx + 1) % STATUS.length;
        if (statusEl) statusEl.textContent = STATUS[sIdx];
      }, 2200);
      /* Safety cap: never trap the shopper behind the loader. */
      setTimeout(finish, 25000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', go);
    } else {
      go();
    }
  } catch (e) { /* never let the loader break the page */ }
})();
